module.exports = __webpack_public_path__ + "static/media/rules_and_consequences_bath_room.b2bf3c6d.png";